<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Switcher examples" />
    <vc-layout :spacing="8">
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">No label, unchecked</h3>
        <vc-switcher id="id-1" name="switch-1" v-model="boolFalse" />
        <div :class="['mt-16']">
          <code>v-model: {{ boolFalse }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">Label, checked</h3>
        <vc-switcher color="primary" id="id-2" name="switch-2" v-model="boolTrue">with label</vc-switcher>
        <div :class="['mt-16']">
          <code>v-model: {{ boolTrue }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">Empty array model</h3>
        <vc-switcher color="warning" id="id-3" name="switch-3" v-model="emptyArray" value="martin">martin</vc-switcher>
        <vc-switcher color="warning" id="id-4" name="switch-4" v-model="emptyArray" value="alex">alex</vc-switcher>
        <vc-switcher color="warning" id="id-5" name="switch-5" v-model="emptyArray" value="john">john</vc-switcher>
        <div :class="['mt-16']">
          <code>v-model: {{ emptyArray }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">Number array model, color, left label</h3>
        <vc-switcher label-position="left" color="error" id="id-6" name="switch-6" v-model="prefilledArray" :value="1">select 1</vc-switcher>
        <vc-switcher label-position="left" color="error" id="id-7" name="switch-7" v-model="prefilledArray" :value="2">select 2</vc-switcher>
        <vc-switcher label-position="left" color="error" id="id-8" name="switch-8" v-model="prefilledArray" :value="3">select 3</vc-switcher>
        <div :class="['mt-16']">
          <code>v-model: {{ prefilledArray }}</code>
        </div>
      </vc-col>
      <vc-col :span="24">
        <h3 :class="titleStyle">Disabled</h3>
        <vc-switcher label-position="left" id="id-9" disabled name="switch-9" v-model="disabledFalse">disabled unchecked</vc-switcher>
        <vc-switcher label-position="left" id="id-10" disabled name="switch-9" v-model="disabledTrue">disabled checked</vc-switcher>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'SwitcherPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      titleStyle: ['title', 'font-grey', 'font-l-600'],
      description: null,
      boolTrue: true,
      boolFalse: false,
      emptyArray: [],
      disabledFalse: false,
      disabledTrue: true,
      prefilledArray: [1, 2]
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/switcher.vue